module.exports = __webpack_public_path__ + "img/7.b254649e.jpg";